/* csd-image-swap.js – Detects broken/expired Google Places photos (100x100 error tiles)
   and swaps them with a clean Corkys fallback. Also handles onerror for truly failed loads. */
(function(){
  var FALLBACK = "https://www.corkyscoffee.com/cdn/shop/files/CORKY_Logo.png?v=1";
  var CHECKED = "data-img-checked";

  function isBroken(img){
    if(!img.complete) return false;
    if(img.naturalWidth <= 100 && img.naturalHeight <= 100 && img.src.indexOf("googleapis")>-1) return true;
    if(img.naturalWidth === 0) return true;
    return false;
  }

  function applyFallback(img){
    if(img.getAttribute(CHECKED)==="fb") return;
    img.setAttribute(CHECKED,"fb");
    img.src = FALLBACK;
    img.style.objectFit = "contain";
    img.style.background = "#1a1a1a";
    img.style.padding = "20%";
  }

  function checkImg(img){
    if(img.getAttribute(CHECKED)) return;
    if(img.complete){
      img.setAttribute(CHECKED,"y");
      if(isBroken(img)) applyFallback(img);
    } else {
      img.setAttribute(CHECKED,"p");
      img.addEventListener("load",function(){
        if(isBroken(img)) applyFallback(img);
        else img.setAttribute(CHECKED,"y");
      });
      img.addEventListener("error",function(){ applyFallback(img); });
    }
  }

  function scanCards(){
    var imgs = document.querySelectorAll(".csd-card img, .csd-store-card img, .ecw-card img, .ecw-store-card img, [class*=\"card\"] img");
    for(var i=0;i<imgs.length;i++){
      var img = imgs[i];
      if(img.src && img.src.indexOf("googleapis")>-1) checkImg(img);
    }
  }

  // Initial scan
  if(document.readyState==="loading") document.addEventListener("DOMContentLoaded",scanCards);
  else scanCards();

  // Re-scan after short delay (for lazy-loaded cards)
  setTimeout(scanCards, 1500);
  setTimeout(scanCards, 3000);

  // Watch for dynamically added cards (Load More, filtering)
  var observer = new MutationObserver(function(mutations){
    var hasNew = false;
    mutations.forEach(function(m){
      if(m.addedNodes.length) hasNew = true;
    });
    if(hasNew) setTimeout(scanCards, 100);
  });
  var grid = document.querySelector(".csd-grid, .ecw-grid, [class*=\"grid\"]");
  if(grid) observer.observe(grid, {childList:true, subtree:true});
  else document.addEventListener("DOMContentLoaded",function(){
    var g = document.querySelector(".csd-grid, .ecw-grid, [class*=\"grid\"]");
    if(g) observer.observe(g, {childList:true, subtree:true});
  });
})();